import Bold from './caret-right.bold.svg?react'
import Duotone from './caret-right.duotone.svg?react'
import Fill from './caret-right.fill.svg?react'
import Regular from './caret-right.regular.svg?react'
import { createIcon } from './factory'

export const CaretRight = createIcon({ regular: Regular, bold: Bold, fill: Fill, duotone: Duotone })
